var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileLogo = function SvgMobileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#148DFD",
    d: "M17.594 0H9.74C4.37 0 0 4.37 0 9.74s4.37 9.74 9.74 9.74h3.684v-4.962H9.74a4.784 4.784 0 0 1-4.778-4.777A4.784 4.784 0 0 1 9.74 4.963h7.854a4.784 4.784 0 0 1 4.778 4.778v.082c0 1.427-.63 2.767-1.728 3.678l-7.311 6.064h.013V26l10.466-8.68a9.713 9.713 0 0 0 3.522-7.497v-.082c0-5.372-4.37-9.741-9.74-9.741"
  })));
};
export { SvgMobileLogo as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTVkNmFlOTAwZjgyMmJmNTUwM2UwM2I3YWM1ZjU5NGYuc3ZnIjs=";